"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
/* eslint-disable */
var _default = function _default() {
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "38",
    height: "38",
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("g", {
    style: {
      mixBlendMode: 'luminosity'
    }
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 38C29.4934 38 38 29.4934 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 29.4934 8.50659 38 19 38Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: "0.2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0417 15.0417C34.0417 25.5351 25.5351 34.0417 15.0417 34.0417C10.8047 34.0417 6.89154 32.6547 3.73157 30.3101C7.19359 34.9761 12.7437 38 19 38C29.4935 38 38 29.4934 38 19C38 12.7436 34.9762 7.19353 30.3102 3.73151C32.6548 6.89148 34.0417 10.8046 34.0417 15.0417Z",
    fill: "#E87474"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M25.7292 26.9167H12.2709V29.2917H25.7292V26.9167Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M16.2292 16.7904L5.63002 12.2708L4.75 14.9332L8.95601 16.4398C8.21834 16.9203 7.68774 17.7125 7.68774 18.6736C7.68774 20.1672 8.8913 21.375 10.3796 21.375C11.8679 21.375 13.0714 20.1672 13.0714 18.6736C13.0714 18.3879 12.9938 18.1151 12.9032 17.8554L15.2068 18.6736L16.2292 16.7904Z",
    fill: "black"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.7708 16.7904L32.37 12.2708L33.25 14.9332L29.044 16.4398C29.7817 16.9203 30.3123 17.7125 30.3123 18.6736C30.3123 20.1672 29.1087 21.375 27.6204 21.375C26.1321 21.375 24.9286 20.1672 24.9286 18.6736C24.9286 18.3879 25.0062 18.1151 25.0968 17.8554L22.7932 18.6736L21.7708 16.7904Z",
    fill: "black"
  })), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "paint0_linear",
    x1: "19.0018",
    y1: "37.9945",
    x2: "19.0018",
    y2: "-0.00182087",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.2719",
    stopColor: "#FFDE63"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0.8509",
    stopColor: "#E25D5D"
  }))));
};
exports.default = _default;